import { useCallback, useState } from "react";
import { useStorageState } from "./useStorageState";

export const useTabs = ({ key }) => {
  const [currentTab, setCurrentTab] = useStorageState({
    key,
    type: "number",
    defaultState: 0,
  });

  const [reloadSignal, setReloadSignal] = useState(true);

  const handleChangeTab = useCallback((event, newValue) => {
    setReloadSignal((prev) => !prev);
    setCurrentTab(newValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    currentTab,
    handleChangeTab,
    reloadSignal,
  };
};
